"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _draftJs = require("draft-js");

var _findBlockWithEntity = _interopRequireDefault(require("./findBlockWithEntity"));

function _default(_ref) {
  var editorState = _ref.editorState,
      entityKey = _ref.entityKey;
  var contentState = editorState.getCurrentContent();
  var blockWithEntity = (0, _findBlockWithEntity.default)({
    contentState: contentState,
    entityKey: entityKey
  });

  var selectionAfterInsertedImage = _draftJs.SelectionState.createEmpty(contentState.getBlockAfter(blockWithEntity.getKey()).getKey());

  return _draftJs.EditorState.forceSelection(editorState, selectionAfterInsertedImage);
}

module.exports = exports.default;